import graphql from 'babel-plugin-relay/macro';
import { commitMutation } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
const mutation = graphql`
  mutation UserUpdateMutation($input: UpdateUserTByUserIdInput!) {
    updateUserTByUserId(input: $input) {
      userT {
        userId
        accountId
        userName
        userRole
        lastName
        firstName
        email
        phone
        address1
        address2
        city
        state
        country
        postalCode
        marqetaUid
        auth0Uid
        userStatus
      }
    }
  }
  `;
    
  function commit(userId,
                  lastName, firstName, email, phone,
                  address1, address2, city, state, country, postalCode, 
                  storeObj) {
    var variables = {
        input: {
            userId,
            userTPatch: {}
        }
    };

    if (lastName != null)
        variables.input.userTPatch.lastName = lastName;
    if (firstName != null)
        variables.input.userTPatch.firstName = firstName;
    if (email != null)
        variables.input.userTPatch.email = email;
    if (phone != null)
        variables.input.userTPatch.phone = phone;    
    if (address1 != null)
        variables.input.userTPatch.address1 = address1;
    if (address2 != null)
        variables.input.userTPatch.address2 = address2;
    if (city != null)
        variables.input.userTPatch.city = city;
    if (state != null)
        variables.input.userTPatch.state = state;
    if (country != null)
        variables.input.userTPatch.country = country;
    if (postalCode != null)
        variables.input.userTPatch.postalCode = postalCode;
    
    return new Promise((resolve, reject) => {
        commitMutation(
            abEnvironment.getEnvironment(), {
                mutation,
                variables,
                updater: (store) => {
                    if (storeObj != null)
                    {
                        // Mutation store - values that have been updated / returned
                        const payload = store.getRootField('updateUserTByUserId');
                        const theUser = payload.getLinkedRecord('userT');
        
                        // Retrieved store.
                        if (storeObj.userString != null)
                        {
                            let preSaveUser = null;

                            const theRoot = store.getRoot();
                            if (storeObj.accountString != null && storeObj.userIdx != null) {
                                let theAcct = theRoot.getLinkedRecord(storeObj.accountString);
                                if (theAcct != null) {
                                    let theUsers = theAcct.getLinkedRecord(storeObj.userString);
                                    if (theUsers != null) {
                                        let theNodes = theUsers.getLinkedRecords('nodes');
                                        if (theNodes != null) {
                                            if (storeObj.userIdx < theNodes.length) {
                                                preSaveUser = theNodes[storeObj.userIdx];
                                            }
                                        }
                                    }
                                }
                            }
                            else
                            {
                                // e.g. 'userTByUserId(userId:"' + userId + '")'
                                preSaveUser = theRoot.getLinkedRecord(storeObj.userString);
                            }
    
                            if (preSaveUser != null) {
                                // Could restrict to just what has changed, but just do all returned values,
                                // which is correct.
                                preSaveUser.setValue(theUser.getValue('lastName'),   'lastName');
                                preSaveUser.setValue(theUser.getValue('firstName'),  'firstName');
                                preSaveUser.setValue(theUser.getValue('email'),      'email');
                                preSaveUser.setValue(theUser.getValue('phone'),      'phone');
                                preSaveUser.setValue(theUser.getValue('address1'),   'address1');
                                preSaveUser.setValue(theUser.getValue('address2'),   'address2');
                                preSaveUser.setValue(theUser.getValue('city'),       'city');
                                preSaveUser.setValue(theUser.getValue('state'),      'state');
                                preSaveUser.setValue(theUser.getValue('country'),    'country');
                                preSaveUser.setValue(theUser.getValue('postalCode'), 'postalCode');
                            }
                        }
                    }
                },
                    onCompleted: (response) => {
                    resolve(response);
                },
                onError: (error) => {
                    reject(error);
                }
        });
    });
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { commit };
  